// extracted by mini-css-extract-plugin
export default {"form":"styles_form__6zRi1","button":"styles_button__kFZv8","center":"styles_center__b6ObA"};